import { createContext, useContext, useEffect, useState } from "react";
import { CSSTransition } from "react-transition-group";
import { useLocation } from "react-router-dom";
import PasswordReset from "features/authentication/components/PasswordReset";
import PasswordCreate from "features/authentication/components/PasswordCreate";

const DialogContext = createContext({});

export const DialogContextProvider = ({ children }) => {
  const [ dialog, setDialog ] = useState();
  const [ visible, setVisible ] = useState();
  const location = useLocation();

  const showDialog = (component) => {
    setDialog(component);
    setVisible(true);
  }

  const hideDialog = () => {
    setVisible(false);
  }

  useEffect(
    () => {
      if (visible) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    }, [ visible ]);

  useEffect(
    () => {
      const urlParams = new URLSearchParams(location.search);
      const passwordToken = urlParams.get('passwordToken');
      const crmId = urlParams.get('crmId');
      const create = urlParams.get('action') === `create`;
      if (create) {
        showDialog(<PasswordCreate token={ passwordToken } crmId={ crmId }/>);
      }
      else if (passwordToken) {
        showDialog(<PasswordReset token={ passwordToken } crmId={ crmId }/>);
      }
    },
    [ location ]
  )

  return (
    <DialogContext.Provider value={ { showDialog, hideDialog } }>
      <CSSTransition
        in={ visible }
        timeout={ 300 }
        classNames="dialog-animate-"
        unmountOnExit>
        { dialog ? dialog : <></> }
      </CSSTransition>
      { children }
    </DialogContext.Provider>
  )
}

export function useDialog() {
  return useContext(DialogContext);
}

export default DialogContextProvider;
